/* import __COLOCATED_TEMPLATE__ from './posting-create.hbs'; */
import Component from '@glimmer/component';
import { get } from '@ember/object';
import { inject as service } from '@ember/service';

const CLASS_NAME = 'SH-c-posting-create';

class PostingCreateComponent extends Component {
  @service('states/routes/posting-create')
  state;

  @service
  session;

  get CLASS_NAME() {
    return CLASS_NAME;
  }

  get currentUser() {
    return this.session.currentUser;
  }

  get freelancerUser() {
    return get(this.state, 'updatedDirectFreelancerUser');
  }
}

export default PostingCreateComponent;
